import { useState } from "react";
import { useLocation } from "react-router-dom";
import { useToastContext } from "../contexts/ToastContext/ToastContext";
import GetUserInfoService from "../service/GetUserInfoService";

function formatDateYYYYMMDD(date) {
  return date.getUTCFullYear() + "-" + (date.getUTCMonth() + 1) + "-" + date.getUTCDate();
}

const useTransactions = () => {
  const { pathname } = useLocation();
  const routeName = pathname.split("-")[1];
  const { showErrorToast } = useToastContext();

  const getUserInfoService = new GetUserInfoService();

  const [statementData, setStatementData] = useState([]);
  const [dateBegin, setDateBegin] = useState(null);
  const [dateEnd, setDateEnd] = useState(null);
  const [loading, setLoading] = useState(false);

  async function getTransactionTable(dateBegin, dateEnd) {
    if (!dateBegin && !dateEnd) {
      showErrorToast({ detail: "emptyDates" });
      return false;
    }

    const formattedDateBegin = formatDateYYYYMMDD(dateBegin);
    const formattedDateEnd = formatDateYYYYMMDD(dateEnd);
    setLoading(true);

    if (routeName === "extracoinStatement") {
      try {
        const res = await getUserInfoService.getExtracoinTransactions(
          localStorage.getItem("__extraconomy_token"),
          localStorage.getItem("__extraconomy_username"),
          formattedDateBegin,
          formattedDateEnd
        );

        setStatementData(res.result);
        setLoading(false);
      } catch (e) {
        setLoading(false);
        console.log(e);
      }
    } else if (routeName === "bonusStatement") {
      try {
        const res = await getUserInfoService.getBonusTransactions(
          localStorage.getItem("__extraconomy_token"),
          localStorage.getItem("__extraconomy_username"),
          formattedDateBegin,
          formattedDateEnd
        );

        setStatementData(res.result);
        setLoading(false);
      } catch (e) {
        setLoading(false);
        console.log(e);
      }
    } else if (routeName === "extrabonusStatement") {
      try {
        const res = await getUserInfoService.getExtrabonusTransactions(
          localStorage.getItem("__extraconomy_token"),
          localStorage.getItem("__extraconomy_username"),
          formattedDateBegin,
          formattedDateEnd
        );

        setStatementData(res.result);
        setLoading(false);
      } catch (e) {
        setLoading(false);
        console.log(e);
      }
    } else {
      try {
        const res = await getUserInfoService.getWalletTransactions(
          localStorage.getItem("__extraconomy_token"),
          localStorage.getItem("__extraconomy_username"),
          formattedDateBegin,
          formattedDateEnd
        );

        setStatementData(res.result);
        setLoading(false);
      } catch (e) {
        setLoading(false);
        console.log(e);
      }
    }
  }

  return {
    statementData,
    setStatementData,
    dateBegin,
    setDateBegin,
    dateEnd,
    setDateEnd,
    loading,
    setLoading,
    getTransactionTable,
    routeName,
  };
};

export default useTransactions;
